import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface DemoReference {
  reference: string;
  search_type: string;
  count: number;
}

export const useDemoReferences = () => {
  return useQuery({
    queryKey: ["demo-references"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("demo_products")
        .select("reference, search_type")
        .order("reference");

      if (error) {
        console.error("Error fetching demo references:", error);
        throw error;
      }

      // Group by reference and search_type, count occurrences
      const grouped = data.reduce((acc: { [key: string]: DemoReference }, item) => {
        const key = `${item.reference}-${item.search_type}`;
        if (!acc[key]) {
          acc[key] = {
            reference: item.reference,
            search_type: item.search_type,
            count: 1,
          };
        } else {
          acc[key].count++;
        }
        return acc;
      }, {});

      return Object.values(grouped);
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
